import React, { useState } from "react";
import EndButton from "./EndButton";

function Button(props) {
    const { text, src, action, btn_id, active, _participants } = props;

    const LoadingIcon = (src) => {
        if (src === "on") {
            return (
                <svg height="24" width="24" viewBox="0 0 32 32">
                    <path
                        fill="red"
                        d="M22.667 16a6.667 6.667 0 11-13.334 0 6.667 6.667 0 0113.334 0z"
                    ></path>
                    <path
                        fill="red"
                        d="M16 24a8 8 0 000-16 8 8 0 000 16zm0 1.333a9.333 9.333 0 110-18.666 9.333 9.333 0 110 18.666z"
                    ></path>
                </svg>
            );
        }
        return (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                x="0px"
                y="0px"
                width="24"
                height="24"
                viewBox="0 0 50 50"
            >
                <path
                    fill="#fff"
                    d="M43.935,25.145c0-10.318-8.364-18.683-18.683-18.683c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615c8.072,0,14.615,6.543,14.615,14.615H43.935z"
                >
                    <animateTransform
                        attributeType="xml"
                        attributeName="transform"
                        type="rotate"
                        from="0 25 25"
                        to="360 25 25"
                        dur="0.6s"
                        repeatCount="indefinite"
                    />
                </path>
            </svg>
        );
    };
    return (
        <>
            {/* FOR ALL TOOLBOX MENU OPTION EXCEPT END  */}
            {btn_id !== "end_call" && (
                <li
                    className={`nav-item webphone-btns ${
                        active ? "active" : ""
                    }`}
                    onClick={action}
                >
                    <a
                        className="nav-link"
                        type="button"
                        href={void 0}
                        id={btn_id}
                    >
                        {["pending", "on"].includes(src) ? (
                            LoadingIcon(src)
                        ) : (
                            <img src={src} alt="chat" />
                        )}
                        <span className="text-13">{text}</span>
                        {text === "Participants" && (
                            <h5 className="participant-count-toolbar">
                                {_participants}
                            </h5>
                        )}
                    </a>
                </li>
            )}

            {/* DROPDOWN MENU FOR TOOLBOX MENU END OPTION */}
            {btn_id === "end_call" && (
                <li className={`nav-item webphone-btns`}>
                    <EndButton btn_id={btn_id} text={text} src={src} />
                </li>
            )}
        </>
    );
}

export default Button;
